export const offerarray = [
  {
    "id": "31",
    "name": "Sari",
    "description": "Traditional Nepali sari, perfect for cultural events and celebrations.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Blue",
    "color2": "Pink",
    "image": "Nepali Sari.avif",
    "price": "1824",
    "price2": "2299",
    "discount": "15%" // Specific discount of 15%
  },
  {
    "id": "32",
    "name": "Daura Sural",
    "description": "Authentic Nepali daura sural, ideal for formal occasions and ceremonies.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Red",
    "color2": "Yellow",
    "image": "Nepali Daura Sural.png",
    "price": "2015",
    "price2": "2514",
    "discount": "20%" // Specific discount of 20%
  },
  {
    "id": "33",
    "name": "Coat",
    "description": "Stylish Nepali coat, suitable for both casual and formal wear.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Green",
    "color2": "Purple",
    "image": "Nepali Coat.webp",
    "price": "2267",
    "price2": "2834",
    "discount": "12%" // Specific discount of 12%
  },
  {
    "id": "34",
    "name": "Kurta",
    "description": "Classic Nepali kurta, perfect for everyday wear or special occasions.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Orange",
    "color2": "Black",
    "image": "Nepali Kurta.jpg",
    "price": "2502",
    "price2": "3149",
    "discount": "10%" // Specific discount of 10%
  },
  {
    "id": "35",
    "name": "Sherwani",
    "description": "Elegant Nepali sherwani, suitable for weddings and formal gatherings.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "White",
    "color2": "Gray",
    "image": "Nepali Sherwani.avif",
    "price": "2599",
    "price2": "3249",
    "discount": "20%" // Specific discount of 20%
  },
  {
    "id": "36",
    "name": "Bakhu",
    "description": "Traditional Nepali bakhu, ideal for cultural events and festivals.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Brown",
    "color2": "Cyan",
    "image": "Nepali Bakhu.jpg",
    "price": "2854",
    "price2": "3564",
    "discount": "15%" // Specific discount of 15%
  },
  {
    "id": "37",
    "name": "kurtha",
    "description": "Stylish Nepali kurtha, suitable for traditional and contemporary occasions.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Beige",
    "color2": "Maroon",
    "image": "kurtha.webp",
    "price": "3119",
    "price2": "3899",
    "discount": "10%" // Specific discount of 10%
  },
  {
    "id": "38",
    "name": "Topi",
    "description": "Authentic Nepali topi, perfect for cultural events and everyday wear.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Navy",
    "color2": "Olive",
    "image": "Nepali Topi.jpg",
    "price": "3231",
    "price2": "4049",
    "discount": "20%" // Specific discount of 20%
  },
  {
    "id": "39",
    "name": "Pant",
    "description": "Modern Nepali pant, suitable for casual outings and daily wear.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Teal",
    "color2": "Turquoise",
    "image": "Nepali Pant.webp",
    "price": "3519",
    "price2": "4399",
    "discount": "12%" // Specific discount of 12%
  },
  {
    "id": "40",
    "name": "Shawl",
    "description": "Traditional Nepali shawl, perfect for keeping warm during cold seasons.",
    "brand": "NepaliTrends",
    "size1": "S",
    "size2": "M",
    "size3": "L",
    "color1": "Gold",
    "color2": "Silver",
    "image": "Nepali Shawl.webp",
    "price": "4079",
    "price2": "5099",
    "discount": "15%" // Specific discount of 15%
  }
];
